import Row from '@totallymoney/ui/components/Row'
import Text from '@totallymoney/ui/components/Text'
import theme from '@totallymoney/ui/theme'

import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

import TooltipButton from '@components/TooltipButton'

import { getRepresentativeExampleTextForCard } from '@utils/getRepresentativeExampleTextForCard'

const RepresentativeExample = ({
    item,
    onTooltipPress,
}: {
    item: ScoredCreditCardProduct
    onTooltipPress: () => void
}) => (
    <>
        <Row space="space10">
            <Text variant="80" weight="bold">
                Representative example
            </Text>
            <TooltipButton
                data-testid="representative-example-tooltip"
                title={`Tooltip icon for representative example - ${item.productCode}`}
                aria-label="What is Representative example?"
                color={theme.grey100}
                onPress={onTooltipPress}
            />
        </Row>

        <Text variant="80" color="light">
            {getRepresentativeExampleTextForCard(item)}
        </Text>
    </>
)

export default RepresentativeExample
